/**
 * Hotspot section behavior.
 * - Hover/focus/click a marker to highlight its card.
 * - Click outside to clear.
 * Re-runs on Shopify theme editor `shopify:section:load` events.
 */
(function () {
  function initSection(section) {
    if (!section || section.dataset.hotspotInit === 'true') return;
    section.dataset.hotspotInit = 'true';

    const hotspots = section.querySelectorAll('.hotspot-section__hotspot');

    const setActive = (target) => {
      hotspots.forEach((h) => h.classList.toggle('is-active', h === target));
    };
    const clearActive = () => {
      hotspots.forEach((h) => h.classList.remove('is-active'));
    };

    hotspots.forEach((hotspot) => {
      const marker = hotspot.querySelector('.hotspot-section__marker');
      if (!marker) return;

      marker.addEventListener('mouseenter', () => setActive(hotspot));
      marker.addEventListener('mouseleave', clearActive);
      marker.addEventListener('focus', () => setActive(hotspot));
      marker.addEventListener('blur', clearActive);
      marker.addEventListener('click', (e) => {
        e.stopPropagation();
        const isActive = hotspot.classList.contains('is-active');
        clearActive();
        if (!isActive) setActive(hotspot);
      });
    });

    section.addEventListener('click', (e) => {
      if (!e.target.closest('.hotspot-section__hotspot')) clearActive();
    });
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.hotspot-section')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
